import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/newspaper': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M552 64H112C91.1 64 73.4 77.4 66.8 96H24C10.7 96 0 106.7 0 120V392C0 422.9 25.1 448 56 448H552C565.3 448 576 437.3 576 424V88C576 74.7 565.3 64 552 64zM48 392V144H64V392C64 396.4 60.4 400 56 400S48 396.4 48 392zM528 400H111.4C111.8 397.4 112 394.7 112 392V112H528V400zM172 280H308C314.6 280 320 274.6 320 268V172C320 165.4 314.6 160 308 160H172C165.4 160 160 165.4 160 172V268C160 274.6 165.4 280 172 280zM200 200H280V240H200V200zM160 340V316C160 309.4 165.4 304 172 304H308C314.6 304 320 309.4 320 316V340C320 346.6 314.6 352 308 352H172C165.4 352 160 346.6 160 340zM352 340V316C352 309.4 357.4 304 364 304H468C474.6 304 480 309.4 480 316V340C480 346.6 474.6 352 468 352H364C357.4 352 352 346.6 352 340zM352 196V172C352 165.4 357.4 160 364 160H468C474.6 160 480 165.4 480 172V196C480 202.6 474.6 208 468 208H364C357.4 208 352 202.6 352 196zM352 268V244C352 237.4 357.4 232 364 232H468C474.6 232 480 237.4 480 244V268C480 274.6 474.6 280 468 280H364C357.4 280 352 274.6 352 268z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/newspaper.js
// module id = d+DC
// module chunks = 144